import { CallCenterTicketData } from "../call-center/call-center-ticket-data";

export class Players1000ListOutDTO {
  id!: string;
  createdAt!: Date;
  data?: CallCenterTicketData | null;
}
